import { Header, Icon, Segment } from 'semantic-ui-react';
import styled from 'styled-components';

export const StyledHeader = styled(Header)`
display: flex;
justify-content: space-between;
 .title {
  font-size: 16px !important;
 }
align-items: center;
height: 55px !important;
`
export const StyledIconInfo = styled(Icon)`
cursor: pointer; 
font-size: 1.2em !important;
margin-left: 5px;
`
export const TitleWrapper = styled.div`
display: flex;
align-items: center;
`
export const StyledColumnValue = styled.div`
font-weight: bold;
margin-top: 5px;
width: fit-content;
`
export const StyledMenuWrapper = styled.div`
position: absolute;
right: 10px;
bottom: 10px;
`
export const StyledContainer = styled.div`
 margin: 1rem;
 .action-icon {
  margin-right: 0 !important;
  font-size: 1.2em !important;
 }
 .actions {
 }
  &:hover { 
    .actions { 
      opacity: 1;
      height: auto;
    }
  } 
`
export const ChartContainer = styled.div`
width: 95%;
height: 500px;
  .header {
    display: flex;
    align-items: baseline;
    font-size: 17px !important;
    font-weight: bold;
    margin-bottom: 20px;
    margin-left: 15px;
  }
 .basic {
  margin-left: 30px;
  width: calc(100% - 30px);
  margin-top: 20px;
 }
`
export const TooltipWrapper = styled.div`
margin: 0;
border: 1px solid #f5f5f5;
background-color: #f3f4f5;
border-radius: 5px;
padding: 5px;
`

export const NoTradingSlotsWrapper = styled(Segment)`
position: relative;
height: 270px;
max-height: 270px;
display: flex;
align-items: center;
justify-content: center;
`
export const TermsWrapper = styled.div<{ firstColor: string }>`
width: inherit;
 .note-title {
  font-size: 18px !important;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
 }
 .title {  
  font-size: 15px !important;
 }
 .item {
  color: ${props => props.firstColor || 'black'};
  font-size: 15px !important;
  cursor: pointer;
 }
 .highlight-label {
  background: rgb(220 226 231);
  color: ${props => props.firstColor || 'black'} !important;
  font-style: italic;
  font-size: 15px !important;
  font-weight: bold !important;
}
`